import { graphql } from "gatsby"
import React, { useContext } from "react"
import Col from "react-bootstrap/Col"

import { SiteContext } from "@context/Provider"
import Card from "@knowit-alma/common/src/components/molecules/Card/Card"
import CardGrid from "@knowit-alma/common/src/components/organisms/CardGrid/CardGrid"

const RelatedContentGrid = ({ blockDataRelatedContentGrid }) => {
  const { heading } = blockDataRelatedContentGrid || {}

  const context = useContext(SiteContext)

  const items =
    context.relatedTaggedContent?.length > 0
      ? context.relatedTaggedContent.map((card, index) => {
          const { id, title, uri, featuredImage, categories } = card.node

          const tagline =
            categories?.nodes.length > 0 ? categories.nodes[0]?.name : null

          return (
            <Col key={id} md="4">
              <Card
                headingSize={heading ? "h3" : "h2"}
                image={featuredImage ? featuredImage.node : false}
                imageAspectRatio={"16:9"}
                tagline={tagline}
                title={title}
                url={uri}
                internalLink={true}
              />
            </Col>
          )
        })
      : null

  return <CardGrid heading={heading} items={items} />
}

export const query = graphql`
  fragment RelatedContentGrid on WpBlockAcfRelatedContentGrid {
    __typename
    blockDataRelatedContentGrid {
      heading
    }
  }
`

export default RelatedContentGrid
